module.exports = __webpack_public_path__ + "static/media/file-alt.432b6473.svg";